import styled from '@emotion/styled';

const InfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

const Title = styled.span`
    color: ${({ theme }) => theme.colors.secondary[900]};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.32px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const StyledAgentDate = styled.span`
    color: ${({ theme }) => theme.colors.black[700]};
    font-size: 14px;
    font-weight: 500;
    letter-spacing: -0.24px;
`;

interface Props {
    name?: string;
    formattedDate: string;
    isError: boolean;
    isDraft: boolean;
}

export const AgentTileInfo = ({ name, formattedDate, isDraft }: Props) => (
    <InfoContainer>
        <Title>{name}</Title>
        <StyledAgentDate>{isDraft ? `Edited ${formattedDate}` : `Created ${formattedDate}`}</StyledAgentDate>
    </InfoContainer>
);
